import React from 'react';
import { FaChartLine } from 'react-icons/fa';
import './FinancePortalButton.css';

export default function FinancePortalButton() {
  const openFinancePortal = () => {
    window.open(
      `${window.location.origin}/finance`,
      '_blank',
      'noopener,noreferrer,width=1280,height=800'
    );
  };

  return (
    <button
      type="button"
      className="finance-portal-fab"
      onClick={openFinancePortal}
      title="Finance Portal (staff only)"
      aria-label="Open Finance Portal"
    >
      <FaChartLine size={20} />
    </button>
  );
}
